import * as React from 'react'

import type { IDomainEvent } from '@app/domain/domain-events/domain-events.interface'

import { BroadcastFailureHeader } from './broadcast-failure'
import { DefaultDomainEventHeader } from './default-domain-event'

interface Props {
  className?: string
  domainEvent: IDomainEvent
  expandedRows: { [key: string]: boolean }
  handleExpanded: (domainEventId: string) => void
  index: number
}

export const DomainEventHeader = function ({
  domainEvent,
  expandedRows,
  handleExpanded,
  index,
}: Props) {
  switch (domainEvent.type) {
    case 'intake.broadcast_failure':
      return (
        <BroadcastFailureHeader
          domainEvent={domainEvent}
          expandedRows={expandedRows}
          handleExpanded={handleExpanded}
          index={index}
        />
      )

    default:
      return (
        <DefaultDomainEventHeader
          domainEvent={domainEvent}
          expandedRows={expandedRows}
          handleExpanded={handleExpanded}
          index={index}
        />
      )
  }
}
